
    import './styles.scoped.css';
    export default {
  "root": "_root_qn3ee_3",
  "token": "_token_qn3ee_14",
  "dismiss-button": "_dismiss-button_qn3ee_26",
  "token-disabled": "_token-disabled_qn3ee_60"
};
  